import { PREFIX } from '../constants';
import asyncBuilder from 'utilities/actions';
import repository from 'client/repository';

export default {
    getTheme: asyncBuilder(PREFIX, (themeName) => {
        return repository.themes.getTheme(themeName);
    })
}